/**
 * Adyen payment refusal reason codes and their corresponding messages
 * @param {number|string} refusalReasonCode - The Adyen refusal reason code
 * @param {Function} t - The i18n translation function
 * @returns {Object|null} Object with reason and description, or null if code not found
 */
export const getRefusalReason = (refusalReasonCode, t) => {
    const refusalReasons = {
        2: {
            reason: t('adyen.refusal.refused.reason'),
            description: t('adyen.refusal.refused.description')
        },
        5: {
            reason: t('adyen.refusal.blockedCard.reason'),
            description: t('adyen.refusal.blockedCard.description')
        },
        6: {
            reason: t('adyen.refusal.expiredCard.reason'),
            description: t('adyen.refusal.expiredCard.description')
        },
        7: {
            reason: t('adyen.refusal.invalidAmount.reason'),
            description: t('adyen.refusal.invalidAmount.description')
        },
        8: {
            reason: t('adyen.refusal.invalidCardNumber.reason'),
            description: t('adyen.refusal.invalidCardNumber.description')
        },
        9: {
            reason: t('adyen.refusal.issuerUnavailable.reason'),
            description: t('adyen.refusal.issuerUnavailable.description')
        },
        10: {
            reason: t('adyen.refusal.notSupported.reason'),
            description: t('adyen.refusal.notSupported.description')
        },
        11: {
            reason: t('adyen.refusal.3DNotAuthenticated.reason'),
            description: t('adyen.refusal.3DNotAuthenticated.description')
        },
        12: {
            reason: t('adyen.refusal.notEnoughBalance.reason'),
            description: t('adyen.refusal.notEnoughBalance.description')
        },
        15: {
            reason: t('adyen.refusal.cancelled.reason'),
            description: t('adyen.refusal.cancelled.description')
        },
        16: {
            reason: t('adyen.refusal.shopperCancelled.reason'),
            description: t('adyen.refusal.shopperCancelled.description')
        },
        24: {
            reason: t('adyen.refusal.CVCDeclined.reason'),
            description: t('adyen.refusal.CVCDeclined.description')
        }
    };

    return refusalReasons[refusalReasonCode] || null;
};
